import { EMPTY_ARRAY_STRING, EMPTY_STRING, INITIAL_PAGE_STATE, INITIAL_SORT_COLUMN_DESC } from './constants';

const today = new Date();
const currentYear = today.getFullYear();
const currentMonth = today.getMonth();

export const INITIAL_DATE_RANGE = {
	start: new Date(currentYear, currentMonth - 1, 1),
	end: new Date(currentYear, currentMonth, 1),
};

export const INITIAL_FILTERS = {
	sortedColumn: INITIAL_SORT_COLUMN_DESC,
	pageState: INITIAL_PAGE_STATE,
	dateRange: INITIAL_DATE_RANGE,
	search: EMPTY_STRING,
	status: EMPTY_ARRAY_STRING,
	startDate: EMPTY_ARRAY_STRING,
	profiles: EMPTY_ARRAY_STRING,
};

export enum FILTERS {
	SORTED_COLUMN = 'sortedColumn',
	PAGE_STATE = 'pageState',
	DATE_RANGE = 'dateRange',
	SEARCH = 'search',
	STATUS = 'status',
	START_DATE = 'startDate',
	PROFILES = 'profiles',
}
